<template>
  <div>
    <b-button variant="link" @click="back">Back</b-button>
    <div v-if="selected">
      <b-form-group id="name-group" label="Name" label-for="name-input">
        <b-form-input type="text" id="name-input" v-model="selected.name" @blur="saveSelected()"></b-form-input>
      </b-form-group>
      <b-form-group id="address-group" label="Address" label-for="address-input">
        <b-form-textarea id="address-input" v-model="selected.address" @blur="saveSelected()"></b-form-textarea>
      </b-form-group>
    </div>
  </div>
</template>

<script>
import { modelMixinNoProp } from '@/mixins';
import ModelField from '@/components/model-field';

export default {
  name: "VenueEditor",
  props: [
    'id'
  ],
  mixins: [modelMixinNoProp],
  components: { ModelField },
  data: () => ({ model: "venue" }),
  methods: {
    back() {
      this.$router.push('/venues/venues')
    },
  },
  mounted() {
    this.select(this.id)
    this.fetchSelected()
  },
}
</script>

<style>

</style>
